import React from "react";
import {
  EditOutlined,
  DeleteOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { Switch } from "antd";
import styles from "./style.module.scss";
import { Button } from "antd";
import samplesec from "../../assets/images/samplesec.png";
import SpiceSelect from "./spiceSelect";

const AllItems = (props) => {
  const {
    onAddItem,
    menuItem,
    setExpandId,
    expandId,
    onDeleteItem,
    onEditItem,
    allData,
    otherItem,
    settingsList
  } = props;
  console.log("menuItem",menuItem)
  let allItem = [...otherItem];
  allData?.map((items) => {
    allItem.push(...items.menu_items);
    return null;
  });
  const showExpand = () => {
    if(expandId.indexOf('all') > -1){
      const currentIds = [...expandId];
      currentIds.splice(expandId.indexOf(menuItem?.id || 0), 1);
      setExpandId(currentIds);
    } else {
      const currentIds = [...expandId];
      currentIds.push('all');
      setExpandId(currentIds);
    }
  };
  return (
    <div
      onClick={() => {
        showExpand();
      }}
      className={styles.card_wrap}
    >
      <div className={styles.head_card}>
        <div className={styles.img_sec}>
          <div className={styles.sec_imgholder}>
            <img src={samplesec} style={{ height: "inherit" }} alt="" />
          </div>
          <span className={styles.sec_name}>All Items</span>
          {expandId.indexOf('all') == -1 ?  (
            <UpOutlined />
          ) : (
            <DownOutlined />
          )}
        </div>
      </div>
      <>
        {expandId.indexOf('all') < 0 && (
          <div className={styles.sec_content}>
            <table style={{ width: "100%" }}>
              <thead>
                <tr className={styles.content_row}>
                  <th className="">Name</th>
                  {settingsList.allow_description && <th>Description</th>}
                  <th>Price</th>
                  {(settingsList.allow_gluten_free || settingsList.allow_vegan || settingsList.allow_vegetarian ) && <th>GF/VT/V</th>}
                  {/* {settingsList.allow_spice_level && <th>Spicy</th>} */}
                  {settingsList.allow_calories && <th>Calories</th>}
                  <th>--</th>
                  <th> </th>
                </tr>
              </thead>
              {allItem?.map((subItems) => {
                return (
                  <tr className={styles.content_list}>
                    <td>
                      <div className={styles.content_one}>
                        <div style={{ width: 60, height: 60, marginRight: 5 }}>
                          <img
                            src={subItems.photo_url}
                            style={{ width: "inherit", height: "inherit" }}
                            alt=""
                          />
                        </div>
                        <div> {subItems.name}</div>
                      </div>
                    </td>
                    {settingsList.allow_description && <td>
                      <div className={styles.content_desc}>
                        {subItems.description}
                      </div>
                    </td>}
                    <td>
                      <div className={styles.content_price}>
                        $ {subItems.price}
                      </div>
                    </td>
                    {(settingsList.allow_gluten_free || settingsList.allow_vegan || settingsList.allow_vegetarian ) && 
                    <td>
                      <div className={styles.content_four}>
                        {subItems.is_gluten_free && settingsList.allow_gluten_free && (
                          <div className={styles.circle_tag}>GF</div>
                        )}
                        {subItems.is_vegetarian && settingsList.allow_vegetarian && (
                          <div
                            className={styles.circle_tag}
                            style={{ backgroundColor: "#9FEC92" }}
                          >
                            VT
                          </div>
                        )}
                        {subItems.is_vegan && settingsList.allow_vegan && (
                          <div
                            className={styles.circle_tag}
                            style={{ backgroundColor: "#04540C" }}
                          >
                            V
                          </div>
                        )}
                      </div>
                    </td>}
                    {/* {settingsList.allow_spice_level &&
                    <td>
                      <div className={styles.content}>
                        {SpiceSelect("", subItems.spice_level)}
                      </div>
                    </td>} */}
                    {settingsList.allow_calories && <td>{subItems.calories || '-'}</td>}
                    <td>
                      <div className={styles.content}>
                        <Switch defaultChecked />
                      </div>
                    </td>
                    <td>
                      <div className={styles.content_actions}>
                        <EditOutlined
                          onClick={() => {
                            onEditItem(subItems, menuItem);
                          }}
                        />
                        <DeleteOutlined
                          style={{ color: "#FF4D4FD9" }}
                          onClick={() => {
                            onDeleteItem(subItems.id);
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
        )}
      </>
    </div>
  );
};
export default AllItems;
